import { memo, useEffect, useState } from "react";
import { SystemBanner } from "../SystemBanner";

import { ReactComponent as TVIcon } from "./images/404.svg";

import styles from "./styles.module.scss";

export type NotFoundBlockProps = {
  homePageUrl?: string
}

export const NotFoundBlock = memo<NotFoundBlockProps>(({ homePageUrl }) => {
  const [ ref, setRef ] = useState<HTMLCanvasElement | null>();

  useEffect(() => {
    let interval: any;

    if (ref) {
      let time = 0;
      const canvas = ref;
      const context = canvas.getContext("2d")!;
      const makeNoise = function () {
        context.beginPath();
        context.arc(50, 50, 50, 0, 2 * Math.PI);
        context.fill();
        const canvasImg = context.createImageData(canvas.width, canvas.height);
        const pix = canvasImg.data;

        for (let i = 0, n = pix.length; i < n; i += 4) {
          const c = 7 + Math.sin(i / 50000 + time / 7);
          pix[i] = pix[i + 1] = pix[i + 2] = 40 * Math.random() * c;
          pix[i + 3] = 255;
        }
        context.putImageData(canvasImg, 0, 0);
        time = (time + 1) % canvas.height;
      };

      interval = setInterval(makeNoise, 50);
    }

    return () => clearInterval(interval);
  }, [ ref ]);

  return (
    <SystemBanner
      image={<>
        <TVIcon />
        <canvas ref={instance => setRef(instance)} />
      </>}
      title="Error 404"
      subTitle="Page not found"
      text="This page does not exist"
      imageBlockClassName={styles.tvBlock}
      homePageUrl={homePageUrl}
    />
  );
});

export default NotFoundBlock;
